import { useContext } from 'react';
import { SettingsContext } from '../contexts/SettingsContext';
import { SettingsContextProps } from '../components/settings/type';

// ----------------------------------------------------------------------

const useSettings = (): SettingsContextProps => useContext(SettingsContext);

export default useSettings;
